import React from 'react';

const DisplayCart = props => {
    const {product} = props;
    return (
        <div>
            <table className="table table-info">
                <tbody>
                    <tr>
                        <th scope="row">{product.name}</th>
                        <td className="text-end">{product.price}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default DisplayCart;